import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Editor, HeadlineEditor } from '../../editor-ui';
import styled from '@emotion/styled';
import { useResource } from 'rest-hooks';
import TextEditorAnnotations from './TextEditorAnnotations';
import useTextEditor from '../../hooks/useTextEditor';
import ContentResource from '../../resources/ContentResource';
import FieldEditor from './FieldEditor';

const PositionContainer = styled.div`
  position: relative;
`;

const NotificationP = styled.p`
  font-family: "Chronicle Text G2 A", "Chronicle Text G2 B", Georgia, "Times New Roman", Times, serif;
  font-size: 18px;
  line-height: 28px;
  font-style: italic;
  color: #666;
  margin-top: 15px;
`;

// An "empty" doc has a size of 2 (opening + closing node)
// Anything with larger size is considered non-empty
const txDocHasContent = (tx) => tx && tx.doc && tx.doc.content.size > 2;

export default function TextEditor({
  historyMode,
  readOnlyMode,
  contentId,
  contentEditorId,
  format,
  storyId,
  style,
  fieldTemplateId,
  fieldTemplate = undefined,
  contentType = undefined
}) {
  const positionContainerRef = useRef(null);
  const [showEditor, setShowEditor] = useState(true);
  const contents = useResource(ContentResource.listShape(), { contentable_id: storyId });
  const { consumerApi, provider } = useTextEditor(
    contentEditorId,
    historyMode,
    readOnlyMode,
    format
  );

  let editor;
  const onDispatchTransaction = (tx) => setShowEditor(txDocHasContent(tx))

  switch (format) {
    case 'emailheadline':
      editor = (
        <HeadlineEditor
          roomName={storyId + '-headline-headline'}
          onDispatchTransaction={() => {}}
          consumerApi={consumerApi}
          plugins={[]}
          format={format}
          style={style}
        />
      );
      break;
    case 'headline':
      editor = (
        <HeadlineEditor
          roomName={storyId + '-headline-headline'}
          onDispatchTransaction={() => {}}
          consumerApi={consumerApi}
          plugins={[]}
          format={format}
          style={style}
        />
      );
      break;
    case 'rich':
      editor = showEditor ? (
        <Editor
          roomName={storyId + '-rich-body'}
          onDispatchTransaction={onDispatchTransaction}
          consumerApi={consumerApi}
          plugins={[]}
        />
      ) : (
        <NotificationP>No text provided</NotificationP>
      );
      break;
    default:
      editor = (
        <FieldEditor
          storyId={storyId}
          format={format}
          fieldTemplateId={fieldTemplateId}
          onDispatchTransaction={onDispatchTransaction}
          consumerApi={consumerApi}
          characterLimit={fieldTemplate && fieldTemplate.character_limit}
          contentType={contentType}
          defaultContent={fieldTemplate.default_content || ''}
        />
      );
      break;
  }

  return (
    <PositionContainer ref={positionContainerRef}>
      <TextEditorAnnotations
        consumerApi={consumerApi}
        contentId={contentId}
        allContentIds={contents.map(c => parseInt(c.id, 10))}
        positionContainerRef={positionContainerRef}
        storyId={storyId}
      />
      {editor}
    </PositionContainer>
  );
}

TextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false,
  format: 'rich',
  fieldTemplateId: undefined,
  fieldTemplate: undefined,
  contentType: undefined
};

TextEditor.propTypes = {
  contentId: PropTypes.number.isRequired,
  contentEditorId: PropTypes.string.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool,
  format: PropTypes.string.isRequired,
  storyId: PropTypes.number.isRequired,
  fieldTemplateId: PropTypes.number,
  fieldTemplate: PropTypes.shape({ character_limit: PropTypes.number }),
  contentType: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/TextEditor.jsx